<!--
 * @Description: 
 * @Date: 2021-07-19 16:35:52
-->
<template>
  <div class="box">
    <el-form :model="formParams" ref="form" label-position="top">
      <div class="flex" v-for="{ title, subTitle, list } in form" :key="title">
        <div class="app-detail-item-title">
          <span>{{ title }}</span>
          <span
            style="font-size: 12px;margin-top: 4px;margin-left: 5px;color:#9c9c9c;"
          >
            {{ subTitle }}
          </span>
        </div>
        <el-form-item
          :label="item.label"
          v-for="item in list"
          :label-width="item.label ? '130px' : '0'"
          :style="{ width: item.width }"
          :key="item.key"
          :prop="item.key"
          :rules="item.rules || []"
        >
          <template v-if="item.slot === 'dicSelect'">
            <dic-select
              style="width:100%;"
              :key="dicSelectKeys[item.key]"
              @dic-select-obj="
                val => {
                  item.callback && item.callback();
                  formParams[item.key] = val[item.attrs.useValueKey];
                  item.key1 &&
                    item.attrs.useValueKey1 &&
                    (formParams[item.key1] = val[item.attrs.useValueKey1]);
                }
              "
              :fuzzyDef="item.selectAjax"
              v-bind="item.attrs"
              :placeholder="item.placeholder"
              class="data-item"
            ></dic-select>
          </template>
          <template v-if="item.slot === 'input'">
            <el-tooltip
              class="item"
              effect="dark"
              :content="formParams[item.key]"
              :disabled="!(item.attrs || {}).disabled || !formParams[item.key]"
              placement="top-start"
            >
              <el-input
                :placeholder="item.placeholder"
                v-model="formParams[item.key]"
                v-bind="item.attrs"
                v-on="item.listeners"
                class="data-item"
              />
            </el-tooltip>
          </template>
          <template v-if="item.slot === 'date'">
            <el-date-picker
              :placeholder="item.placeholder"
              :value-format="item.valueFormat"
              v-model="formParams[item.key]"
              class="data-item"
              :type="item.type || 'month'"
            ></el-date-picker>
          </template>
          <template v-if="item.slot === 'custom'">
            <component
              :ref="item.ref"
              :is="item.component"
              :value="formParams[item.key]"
              v-bind="item.attrs"
              v-on="item.listeners"
            ></component>
          </template>
        </el-form-item>
      </div>
    </el-form>
    <div style="text-align: center;padding-bottom:15px;">
      <template v-if="isEdit">
        <el-button type="primary" @click="edit(1)" :disabled="isSaving">
          保存并提交
        </el-button>
        <el-button type="primary" @click="edit(0)" :disabled="isSaving">
          保存
        </el-button>
        <el-button @click="$xrkDialog.remove()">关闭</el-button>
      </template>
    </div>
  </div>
</template>

<script>
import { moneyInt } from '@/tools/money';
import { invoice } from '@/api/ajax';
import dicSelect from '@/components/Common/dicSelect.vue';
export default {
  name: 'add-dutypaid-proof',
  components: { dicSelect },
  props: { id: [Number, String], isEdit: [Boolean] },
  data() {
    return {
      isSaving: false,
      dicSelectKeys: {
        itemId: 1
      },
      formParams: {
        csoEnterpriseId: '',
        address: []
      }
    };
  },
  computed: {
    form() {
      const { $confirm, isEdit, formParams } = this;
      const checkNumber = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('不能为空'));
        } else if (isNaN(value)) {
          callback(new Error('请填写数字'));
        } else if (!/^(\d+|\d+\.\d{1,2})$/.test(`${value}`)) {
          callback(new Error('最多填写两位小数'));
        } else {
          callback();
        }
      };
      const inputRequired = [
        { required: true, message: '请输入内容', trigger: 'blur' }
      ];
      const selectRequired = [
        { required: true, message: '请选择内容', trigger: 'change' }
      ];
      return [
        {
          title: '发票信息',
          list: [
            {
              label: '开票服务商',
              slot: 'dicSelect',
              key: 'csoEnterpriseId',
              key1: 'csoEnterpriseName',
              selectAjax: invoice.getInvoiceCate,
              callback: () => {
                formParams['itemId'] = '';
                formParams['itemName'] = '';
                this.dicSelectKeys.itemId++;
              },
              attrs: {
                useValueKey: 'id',
                useValueKey1: 'enterpriseName',
                prop: {
                  label: 'enterpriseName',
                  code: 'id'
                },
                ajaxQuery: 'enterpriseName',
                ajaxQueryObj: {},
                defaultActive: {
                  enterpriseName: formParams.csoEnterpriseName,
                  id: formParams.csoEnterpriseId
                },
                isDisabled: !isEdit
              },
              rules: selectRequired
            },
            {
              label: '发票类别',
              slot: 'dicSelect',
              key: 'invoiceType',
              key1: 'invoiceTypeName',
              selectAjax: () => {
                return new Promise(resolve => {
                  resolve({
                    data: {
                      data: [
                        {
                          label: '增值税普通发票',
                          key: 1
                        },
                        {
                          label: '增值税专用发票',
                          key: 2
                        }
                      ]
                    }
                  });
                });
              },
              attrs: {
                defaultActive: {
                  label: formParams.invoiceTypeName,
                  key: formParams.invoiceType
                },
                useValueKey: 'key',
                useValueKey1: 'label',
                prop: {
                  label: 'label',
                  code: 'key'
                },
                isDisabled: !isEdit
              },
              rules: selectRequired
            },
            {
              label: '开票类目',
              slot: 'dicSelect',
              key: 'itemId',
              key1: 'itemName',
              selectAjax: invoice.getInvoiceCate,
              attrs: {
                useValueKey: 'id',
                useValueKey1: 'itemName',
                prop: {
                  label: 'itemName',
                  code: 'id'
                },
                defaultActive: {
                  itemName: formParams.itemName,
                  id: formParams.itemId
                },
                ajaxQuery: 'itemName',
                ajaxQueryObj: {
                  csoId: formParams.csoEnterpriseId
                },
                isDisabled: !isEdit || !formParams.csoEnterpriseId
              },
              rules: selectRequired
            },
            {
              label: '开票金额（元）',
              slot: 'input',
              key: 'invoiceAmount',
              attrs: {
                maxlength: 9,
                disabled: !isEdit
              },
              rules: [
                {
                  validator: checkNumber,
                  trigger: 'blur'
                },
                ...inputRequired
              ]
            }
          ]
        },
        {
          title: '开票信息',
          list: [
            {
              label: '发票抬头',
              slot: 'input',
              key: 'enterpriseName',
              attrs: {
                disabled: true
              }
            },
            {
              label: '纳税人识别号',
              slot: 'input',
              key: 'enterpriseIdentifierNo',
              attrs: {
                disabled: true
              }
            },
            {
              label: '联系电话',
              slot: 'input',
              key: 'enterprisePhone',
              attrs: {
                disabled: true
              }
            },
            {
              label: '开户银行',
              slot: 'input',
              key: 'openBank',
              attrs: {
                disabled: true
              }
            },
            {
              label: '银行账号',
              slot: 'input',
              key: 'bankNo',
              attrs: {
                disabled: true
              }
            },
            {
              label: '企业地址',
              slot: 'input',
              key: 'enterpriseAddress',
              attrs: {
                disabled: true
              }
            }
          ]
        },
        {
          title: '发票邮寄地址',
          list: [
            {
              label: '收件人',
              slot: 'input',
              key: 'receiptFullName',
              attrs: {
                disabled: true
              }
            },
            {
              label: '联系电话',
              slot: 'input',
              key: 'receiptPhone',
              attrs: {
                disabled: true
              }
            },
            {
              label: '邮寄地址',
              slot: 'input',
              key: 'receiptAddress',
              attrs: {
                disabled: true
              }
            }
          ]
        }
      ];
    }
  },
  methods: {
    saveInfo(params) {
      if (this.isSaving) {
        return;
      }
      this.isSaving = true;
      invoice
        .saveInvoiceApply({
          ...params,
          invoiceOpenBank: params.openBank,
          invoiceTitle: params.enterpriseName,
          gongyeEnterpriseId: params.enterpriseId,
          invoiceIdentifierNo: params.enterpriseIdentifierNo,
          invoiceEnterpriseAddress: params.enterpriseAddress,
          invoicePhone: params.enterprisePhone,
          invoiceBankNo: params.bankNo,
          invoiceAmount: parseInt(params.invoiceAmount * 100)
        })
        .then(res => {
          this.$emit('confirm');
          this.$message.success('保存成功');
          this.$xrkDialog.remove();
        })
        .catch(() => {
          this.isSaving = false;
        });
    },
    checkForm(form) {
      return new Promise((resolve, reject) => {
        form.validate(vaild => {
          if (vaild) {
            resolve('ok');
          } else {
            reject('fail');
          }
        });
      });
    },
    edit(status) {
      const { form } = this.$refs;
      Promise.all([this.checkForm(form)]).then(() => {
        this.saveInfo({
          ...this.formParams,
          invoiceStatus: status
        });
      });
    },
    async getBaseInfo() {
      const {
        data: {
          data: { info, address }
        }
      } = await invoice.applyInvoice();
      const { receiptFullName, receiptPhone, receiptAddress } = address;
      const {
        enterpriseId,
        enterpriseName,
        enterpriseIdentifierNo,
        enterprisePhone,
        openBank,
        bankNo,
        enterpriseAddress
      } = info;
      this.formParams = {
        invoiceType: '',
        invoiceTypeName: '',
        itemId: '',
        itemName: '',
        csoEnterpriseId: '',
        csoEnterpriseName: '',
        invoiceAmount: '',

        receiptFullName,
        receiptPhone,
        receiptAddress,
        enterpriseName,
        enterpriseId,
        enterpriseIdentifierNo,
        enterprisePhone,
        openBank,
        bankNo,
        enterpriseAddress
      };
    },
    async getInvioceInfo() {
      const {
        data: { data }
      } = await invoice.detail({ id: this.id });
      const {
        invoiceType,
        invoiceTypeName,
        itemName,
        itemId,
        csoEnterpriseName,
        csoEnterpriseId,
        invoiceAmount,
        receiptFullName,
        receiptPhone,
        receiptAddress,
        enterpriseName,
        invoiceIdentifierNo,
        invoicePhone,
        invoiceOpenBank,
        invoiceBankNo,
        invoiceEnterpriseAddress
      } = data;
      this.formParams = {
        id: this.id,

        invoiceType,
        invoiceTypeName,
        itemName,
        itemId,
        csoEnterpriseName,
        csoEnterpriseId,
        invoiceAmount: moneyInt(invoiceAmount),
        receiptFullName,
        receiptPhone,
        receiptAddress,
        enterpriseName,

        enterpriseIdentifierNo: invoiceIdentifierNo,
        enterprisePhone: invoicePhone,
        openBank: invoiceOpenBank,
        bankNo: invoiceBankNo,
        enterpriseAddress: invoiceEnterpriseAddress
      };
      console.log(data);
    }
  },
  async created() {
    if (this.id) {
      // 查看发票详情
      this.getInvioceInfo();
      return;
    }
    if (this.isEdit) {
      // 新增发票
      this.getBaseInfo();
    }
  }
};
</script>
<style lang="scss" scoped>
.box {
  .flex {
    display: flex;
    flex-wrap: wrap;
    .app-detail-item-title {
      font-size: 18px;
      width: 100%;
      margin-bottom: 30px;
    }
  }
  .el-form {
    &-item {
      width: 250px;
      margin-bottom: 25px;
      margin-right: 25px;
    }
  }
}
</style>
